<template>
  <div class="column is-12 is-paddingless">
      <a
          id="shopahl"
          class="shop-ahl shopahl accordion-title"
          href="https://www.ahlpokerstore.com"
          target="_blank"
      ><span>Shop AHL</span></a>
      <a
          id="joinmailinglist"
          href="/subscribe"
          class="shop-ahl shopahl accordion-title"
      ><span>Join mailing list</span></a>
    <div class="member-links">
      <div
        class="accordion-title"
        :class="{'active': standing}"
        @click="toggleStanding()"
      >
        Point Standings
      </div>
      <div
        v-if="standing"
        class="panel"
      >
        <router-link to="/standing">
          Point Standings
        </router-link>
        <router-link to="/races">
          Current Point Races
        </router-link>
      </div>
      <div v-if="user">
        <div
          v-if="user['menu_options']"
          class="accordion-title button-tools"
          :class="{'active': admin}"
          @click="toggleAdmin()"
        >
          AHL Admin Tools
        </div>
        <div
          v-if="admin && user['menu_options']"
          class="panel"
        >
          <div
            v-for="(option, index) in user['menu_options']"
            :key="index"
            @click="menu(index)"
          >
            <router-link
              class="menu"
              :to="`${option.link}`"
            >
              <ul class="menu-list">
                <li>
                  <a
                    class="is-active"
                    :class="{'menu-list-label': option.children.length}"
                  >{{ option.name }}</a>
                  <ul
                    :ref="`menu-item-${index}`"
                    style="display: none"
                  >
                    <li>
                      <router-link
                        v-for="(child, index) in option.children"
                        :key="index"
                        :to="child.link"
                      >
                        {{ child.name }}
                      </router-link>
                    </li>
                  </ul>
                </li>
              </ul>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.shopahl {
  background: #4267b2;
  border-color: #3273dc #3273dc #29487d;
  color: #fff !important;
  padding: 0.7rem;
  width: 100%;
  display: flex;
}
.shopahl.accordion-title:after {
  content: none;
}
.shopahl span {
  color: #fff !important;
}
</style>
<script>
  export default {
    name: 'MemberLinks',
    props: ['user'],
    data () {
      return {
        photos: false,
        standing: false,
        admin: false,
        showMenu: true,
      }
    },
    computed: {
      options () {
        return Object.entries(this.user['menu_options'])
      }
    },
    mounted () {
      if (window.innerWidth <= 1024) {
        this.showMenu = false
      }
    },
    methods: {
      menu (index) {
        if (this.$refs[`menu-item-${index}`][0].getAttribute('style') === 'display: none;') {
          this.$refs[`menu-item-${index}`][0].style.display = 'block'
        } else this.$refs[`menu-item-${index}`][0].style.display = 'none'
      },
      toggleStanding () {
        this.standing = !this.standing
      },
      toggleAdmin () {
        this.admin = !this.admin
      },
      toggleMenu () {
        this.showMenu = !this.showMenu
      }
    }
  }
</script>
